export default __webpack_public_path__ + "icon31523fd.png";